import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const LEAVE_TYPES = ["Casual", "Sick", "Earned"];

/**
 * LeaveRequestDialog — Apply/edit leave modal.
 *
 * Props:
 *  - open, onClose       : dialog open state + close handler
 *  - editing             : existing leave being edited (null = new request)
 *  - form, setForm       : controlled { start_date, end_date, leave_type, reason } form state
 *  - onSubmit            : (event) => void  handler for form submission
 */
const LeaveRequestDialog = ({ open, onClose, editing, form, setForm, onSubmit }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="leave-request-modal">
      <DialogHeader>
        <DialogTitle>{editing ? "Edit Leave Request" : "Apply for Leave"}</DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Start Date *</Label>
            <Input
              type="date"
              value={form.start_date}
              onChange={(e) => setForm({ ...form, start_date: e.target.value })}
              data-testid="leave-start-date"
            />
          </div>
          <div className="space-y-2">
            <Label>End Date *</Label>
            <Input
              type="date"
              value={form.end_date}
              onChange={(e) => setForm({ ...form, end_date: e.target.value })}
              data-testid="leave-end-date"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Leave Type</Label>
          <Select value={form.leave_type} onValueChange={(v) => setForm({ ...form, leave_type: v })}>
            <SelectTrigger data-testid="leave-type-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {LEAVE_TYPES.map((type) => (
                <SelectItem key={type} value={type}>{type}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Reason *</Label>
          <textarea
            value={form.reason}
            onChange={(e) => setForm({ ...form, reason: e.target.value })}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-prepify-500/20 focus:border-prepify-500 min-h-[80px]"
            placeholder="Please provide reason for leave..."
            data-testid="leave-reason"
          />
        </div>
        <p className="text-sm text-slate-500">
          Note: Leave requests are sent to Admin for approval.
        </p>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" data-testid="submit-leave-btn">
            {editing ? "Update Request" : "Submit Request"}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export default LeaveRequestDialog;
